/* eslint-disable @typescript-eslint/ban-types */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { defaultTheme, withTheme } from '@shared/lib/theme';
interface DotProps {
  color?: keyof typeof defaultTheme['colors']['icon'] | (string & {});
}
const Dot: FC<DotProps> = ({
  color = 'primary'
}) => <DotWrapper color={color} />;
export default Dot;
const _exp = /*#__PURE__*/() => ({
  color,
  theme
}) => color in theme.colors.icon ? theme.colors.icon[color] : color;
const DotWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "DotWrapper",
  class: "d19tq8pn",
  propsAsIs: false,
  vars: {
    "d19tq8pn-0": [_exp()]
  }
}));

require("./Dot.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Dot.tsx");